<template>
  <div class="pos__nav_menu_items">
    <div>
      <!-- POS menu items -->
      <ul class="flex">
        <li @click="navigateTo(item)" class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" v-for="(item, index) in menuItems" :key="index">
          <vx-tooltip :text="item.title" v-if="item.title" class="flex items-center">
            <feather-icon @click="item.cb && item.cb()" :icon="item.icon" svgClasses="w-6 mr-1" />
            <span v-show="item.isTitleShow">{{ item.title }}</span>
          </vx-tooltip>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { routeMixins } from '@/mixins/route'

export default {
  name: 'PosNavMenuItems',
  data() {
    return {
      menuItems: [
        {
          icon: 'ListIcon',
          title: 'Invoices',
          isTitleShow: true,
          cb: () => {
            this.$router.push({ name: 'pos-invoice-list' })
          }
        },
        // {
        //   icon: 'FilePlusIcon',
        //   title: 'New Invoice',
        //   cb: () => {
        //     this.forceUpdate()
        //   }
        // },
        {
          icon: 'BoxIcon',
          title: 'Products',
          isTitleShow: true,
          cb: () => {
            this.$router.push({ name: 'product-list' })
          }
        }
      ]
    }
  },
  mixins: [routeMixins],
  methods: {
    // Navigate to Route
    navigateTo(item) {
      if (item.link || item.link === '') {
        this.$router.push(`/${item.link}`).catch(() => {})
      }

      if (item.action) {
        item.action()
      }

      if (item.cb) {
        item.cb()
      }
    }
  }
}
</script>

<style>
</style>